<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitSupplierData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('suppliers.supplier_process') }}</h3>
        </div>
        <div class="row  mb-4">
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('suppliers.withholding_tax_rate') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.withholding_tax_rate.$error}"
                v-model="formData.withholding_tax_rate"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
          </div>

          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('suppliers.other_tax') }}</label>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.other_tax.$error}"
                v-model="formData.other_tax"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.withholding_tax_rate.$error">
              <span v-if="!$v.formData.withholding_tax_rate.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.supplier_id') }}</label><span class="text-danger"> * </span>
            <base-input
              :class="{'invalid' : $v.formData.supplier_id.$error}"
              v-model.trim="formData.supplier_id"
              :label="$t('general.supplier_id')"
              type="text"
              tab-index="2"
              @input="$v.formData.supplier_id.$touch()"
            />
            <div v-if="$v.formData.supplier_id.$error">
              <span v-if="!$v.formData.supplier_id.required" class="form-group__message text-danger">{{ $t('validation.required') }}</span>
              <span v-if="!$v.formData.supplier_id.alphaNum" class="form-group__message text-danger">{{ $t('validation.alphaNum') }}</span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.payment_term') }}</label>
            <base-input
              :class="{'invalid' : $v.formData.tenor.$error}"
              v-model.trim="formData.tenor"
              :label="$t('general.tenor')"
              type="numeric"
              tab-index="2"
              @input="$v.formData.tenor.$touch()"
            />
            <div v-if="$v.formData.tenor.$error">
              <span v-if="!$v.formData.tenor.numeric" class="form-group__message text-danger">{{ $t('validation.numbers_only') }}</span>
              <span v-if="!$v.formData.tenor.minValue" class="form-group__message text-danger">
                Should be greater than 0
              </span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.approval_days') }}</label>
            <base-input
              :class="{'invalid' : $v.formData.approval_days.$error}"
              v-model.trim="formData.approval_days"
              :label="$t('general.approval_days')"
              type="numeric"
              tab-index="2"
              @input="$v.formData.approval_days.$touch()"
            />
            <div v-if="$v.formData.approval_days.$error">
              <span v-if="!$v.formData.approval_days.numeric" class="form-group__message text-danger">{{ $t('validation.numbers_only') }}</span>
              <span v-if="!$v.formData.approval_days.minValue" class="form-group__message text-danger">
                Should be greater than 0
              </span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.cif_buyer') }}</label>
            <base-input
              :class="{'invalid' : $v.formData.cif_buyer.$error}"
              v-model.trim="formData.cif_buyer"
              :label="$t('general.cif_buyer')"
              type="text"
              tab-index="2"
              @input="$v.formData.cif_buyer.$touch()"
            />
            <div v-if="$v.formData.cif_buyer.$error">
              <span v-if="!$v.formData.cif_buyer.required" class="form-group__message text-danger">{{ $t('validation.required') }}</span>
              <span v-if="!$v.formData.cif_buyer.alphaNum" class="form-group__message text-danger">{{ $t('validation.alphaNum') }}</span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.cif_seller') }}</label>
            <base-input
              :class="{'invalid' : $v.formData.cif_seller.$error}"
              v-model.trim="formData.cif_seller"
              :label="$t('general.cif_seller')"
              type="text"
              tab-index="2"
              @input="$v.formData.cif_seller.$touch()"
            />
            <div v-if="$v.formData.cif_seller.$error">
              <span v-if="!$v.formData.cif_seller.required" class="form-group__message text-danger">{{ $t('validation.required') }}</span>
              <span v-if="!$v.formData.cif_seller.alphaNum" class="form-group__message text-danger">{{ $t('validation.alphaNum') }}</span>
            </div>
          </div>
          <div class="col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.program_code') }}</label>
            <base-input
              :class="{'invalid' : $v.formData.program_code.$error}"
              v-model.trim="formData.program_code"
              :label="$t('general.program_code')"
              type="text"
              tab-index="2"
              @input="$v.formData.program_code.$touch()"
            />
            <div v-if="$v.formData.program_code.$error">
              <span v-if="!$v.formData.program_code.required" class="form-group__message text-danger">{{ $t('validation.required') }}</span>
              <span v-if="!$v.formData.program_code.alphaNum" class="form-group__message text-danger">{{ $t('validation.alphaNum') }}</span>
            </div>
          </div>
        </div>
        <div class="row ">
          <div class="col-md-12">
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, between, numeric, minValue, alphaNum } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
      formData: {
        withholding_tax_rate: 0,
        other_tax: null,
        tenor: null,
        supplier_id: null,
        approval_days: null,
        cif_buyer: null,
        cif_seller: null,
        program_code: null
      },
      defaultInput: {
        decimal: '.',
        thousands: ',',
        prefix: '% ',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapGetters('supplier', [
      'viewSupplier'
    ])
  },
  validations () {
    return {
      formData: {
        withholding_tax_rate: {
          required,
          between: between(0, 99)
        },
        other_tax: {
          between: between(0, 99)
        },
        tenor: {
          numeric,
          minValue: minValue(1)
        },
        supplier_id: {
          required,
          alphaNum
        },
        approval_days: {
          numeric,
          minValue: minValue(1)
        },
        cif_buyer: {
          required,
          alphaNum
        },
        cif_seller: {
          required,
          alphaNum
        },
        program_code: {
          required,
          alphaNum
        }
      }
    }
  },
  created () {
    this.getCompanyImpactOnAccount()
  },
  mounted () {},
  methods: {
    ...mapActions('companyImpactOthers', [
      'addCompanyImpactOthers',
      'fetchCompanyImpactAccount',
      'getImpact'
    ]),
    ...mapActions('supplier', [
      'fetchViewSupplier'
    ]),
    async getCompanyImpactOnAccount () {
      let response, data
      if (this.viewSupplier && this.viewSupplier.default_company_id && localStorage.getItem('selectedCompany')) {
        data = {
          company_id: localStorage.getItem('selectedCompany'),
          guest_company_id: this.viewSupplier.default_company_id
        }
      } else {
        let supplierResponse = await this.fetchViewSupplier(this.$route.params.id)
        if (supplierResponse.data && supplierResponse.data.supplier.default_company_id) {
          data = {
            company_id: localStorage.getItem('selectedCompany'),
            guest_company_id: supplierResponse.data.supplier.default_company_id
          }
        }
      }

      response = await this.getImpact(data)

      if (response.data) {
        if (response.data.withholding_tax_rate) {
          this.formData.withholding_tax_rate = Number(response.data.withholding_tax_rate)
        }
        if (response.data.other_tax) {
          this.formData.other_tax = Number(response.data.other_tax)
        }
        if (response.data.sales_tax_withholding) {
          this.formData.sales_tax_withholding = Number(response.data.sales_tax_withholding)
        }
        if (response.data.tenor) {
          this.formData.tenor = Number(response.data.tenor)
        }
        if (response.data.supplier_id) {
          this.formData.supplier_id = response.data.supplier_id
        }
        if (response.data.approval_days) {
          this.formData.approval_days = Number(response.data.approval_days)
        }
        if (response.data.cif_buyer) {
          this.formData.cif_buyer = response.data.cif_buyer
        }
        if (response.data.cif_seller) {
          this.formData.cif_seller = response.data.cif_seller
        }
        if (response.data.program_code) {
          this.formData.program_code = response.data.program_code
        }
      }
    },
    async submitSupplierData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      this.isLoading = true
      let data = {
        guest_user_id: this.$route.params.id,
        withholding_tax_rate: this.formData.withholding_tax_rate.toFixed(2),
        other_tax: this.formData.other_tax.toFixed(2),
        tenor: this.formData.tenor,
        supplier_id: this.formData.supplier_id,
        approval_days: this.formData.approval_days,
        cif_buyer: this.formData.cif_buyer,
        cif_seller: this.formData.cif_seller,
        program_code: this.formData.program_code

      }
      let response = await this.addCompanyImpactOthers(data)
      if (response.data.result === true) {
        window.toastr['success'](this.$t('customers.updated_message'))
        this.isLoading = false
      } else if (response.data.result === false) {
        window.toastr['error'](response.data.message)
        this.isLoading = false
      }
    }
  }
}
</script>
